import { Component, OnInit } from '@angular/core';
import { base_https_url, TRACKERROR_CONTACT_LINK } from 'src/app/config/app-settings.config';

@Component({
  selector: 'app-corporate-card',
  templateUrl: './corporate-card.component.html',
  styleUrls: ['./corporate-card.component.scss']
})
export class CorporateCardComponent implements OnInit {
  base_url: any;
  trackerror_contact_link: any;

  constructor() { }

  ngOnInit() {
    this.base_url = base_https_url;
    this.trackerror_contact_link = TRACKERROR_CONTACT_LINK;
  }
  redirectToCorporate() {
    window.location.href = "https://www.sbicard.com/en/corporate/track.page";
    
  }
}
